import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { isString } from 'lodash';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

const mutateSubscription = async ({ payload, isEdit }) => {
  if (isEdit) {
    const { data } = await apiClient.patch(`/subscriptions/${payload.stripe_subscription_id}/limits`, payload);
    return data;
  }
  const { data } = await apiClient.post('/subscriptions', payload);
  return data;
};

export const useMutateSubscriptionHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: mutateSubscription,
    onSuccess: (_, variables) => {
      dispatch(showSnackbar({ message: 'Subscription saved successfully.' }));
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
      if (onSuccess) onSuccess(variables);
    },
    onError: (err) => {
      if (err instanceof AxiosError) {
        if (err.response?.status === 400) {
          setError(err.response.data.errors);
          return;
        }
        const message =
          err.response?.data?.errors?.message || err.response?.data?.message || err.message || 'An error occurred';
        dispatch(showSnackbar({ message: message, severity: 'error' }));
        return;
      }
      dispatch(
        showSnackbar({
          message: isString(err?.message) ? err.message : JSON.stringify(err?.message),
          severity: 'error',
        }),
      );
    },
  });

  const onSubmit = async (payload, isEdit) => mutation.mutate({ payload, isEdit });

  return {
    data: mutation.data,
    isError: mutation.isError,
    error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};
